/**
 * 招聘需求 / 岗位列表 —— 4 大模块之一。
 * 显示所有岗位卡片,可点进详情(简历筛选都在那)。
 */

import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { listJobs } from '../api/interview';
import type { Job } from '../api/types';

export default function AdminJobList() {
  const nav = useNavigate();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listJobs().then(setJobs).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1 className="title">招聘需求</h1>
          <div className="subtitle">{jobs.length} 个岗位 · 创建后即可上传简历筛选</div>
        </div>
        <div className="actions">
          <Link to="/admin/jobs/new"><button>+ 新建岗位</button></Link>
        </div>
      </div>

      {loading ? (
        <div className="hint">加载中...</div>
      ) : jobs.length === 0 ? (
        <div className="card">
          <div className="empty">
            <div className="icon">📋</div>
            <div>还没有岗位</div>
            <div className="hint" style={{ marginTop: 6 }}>新建岗位后,AI 会帮你生成能力清单</div>
            <div style={{ marginTop: 16 }}>
              <Link to="/admin/jobs/new"><button>新建第一个岗位</button></Link>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {jobs.map((j) => {
            const caps = (j.capabilities || []).filter((c) => c.selected);
            const must = caps.filter((c) => c.priority === 'must_have').length;
            return (
              <div key={j.id}
                   className="card card-clickable"
                   style={{ marginBottom: 0 }}
                   onClick={() => nav(`/admin/job/${j.id}`)}>
                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 8 }}>{j.title}</div>
                <div className="muted" style={{ fontSize: 13, marginBottom: 12, minHeight: 40 }}>
                  {j.description.slice(0, 100)}{j.description.length > 100 ? '...' : ''}
                </div>
                <div className="row" style={{ gap: 8, flexWrap: 'wrap', fontSize: 12 }}>
                  <span className="chip">{caps.length} 条能力 · {must} 必备</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

